/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesComplexityDto } from '../../models/sales-complexity-dto';
import { SalesQuotePriceListResponseDto } from '../../models/sales-quote-price-list-response-dto';

export interface QuotePriceListsControllerUpdateComplexity$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the quote price list.
 */
  priceListId: string;

/**
 * The code of the complexity to update.
 */
  complexityCode: string;
      body: SalesComplexityDto
}

export function quotePriceListsControllerUpdateComplexity(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerUpdateComplexity$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesQuotePriceListResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerUpdateComplexity.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('priceListId', params.priceListId, {});
    rb.path('complexityCode', params.complexityCode, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesQuotePriceListResponseDto>;
    })
  );
}

quotePriceListsControllerUpdateComplexity.PATH = '/o2-sales/quote-price-lists/{tenant}/{priceListId}/complexities/{complexityCode}';
